module.exports = __webpack_public_path__ + "static/media/test.154666dc.jpg";